import { defineMessages } from "react-intl";

export default defineMessages({
  iAmLabel: {
    id: "Appointment.AppointmentCheckoutFormChoice.iAmLabel",
    defaultMessage: "I am",
  },
  isPatientOption: {
    id: "Appointment.AppointmentCheckoutFormChoice.isPatientOption",
    defaultMessage: "The patient",
  },
  isFamilyMemberOption: {
    id: "Appointment.AppointmentCheckoutFormChoice.isFamilyMemberOption",
    defaultMessage: "A family member of the patient",
  },
  isLegalGuardianOption: {
    id: "Appointment.AppointmentCheckoutFormChoice.isLegalGuardianOption",
    defaultMessage: "The patient's legal guardian",
  },
  isOtherPersonOption: {
    id: "Appointment.AppointmentCheckoutFormChoice.isOtherPersonOption",
    defaultMessage: "None of the above",
  },
});
